import React, { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { scrollToMap } from '../sections/AmbHeroSection';
import { trackEvent, FunnelSteps } from '../../lib/analytics';
import { siteConfig } from '../../config/site';
import { cn } from '../../lib/cn';

export function StickyMobileCta() {
  const [showBar, setShowBar] = useState(true);

  useEffect(() => {
    const mapSection = document.getElementById(siteConfig.anchors.map);
    if (!mapSection) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setShowBar(!entry.isIntersecting);
      },
      { threshold: 0.08, rootMargin: '0px 0px 0px 0px' },
    );

    observer.observe(mapSection);
    return () => observer.disconnect();
  }, []);

  const handleClick = (e) => {
    e.preventDefault();
    trackEvent(FunnelSteps.CTA_CLICKED, { location: 'sticky_mobile' });
    scrollToMap();
  };

  return (
    <div
      className={cn(
        'fixed inset-x-0 bottom-0 z-[150] border-t border-brand-dark/10 bg-white/95 p-3 backdrop-blur-md transition-transform duration-300 ease-out md:hidden',
        showBar ? 'translate-y-0' : 'pointer-events-none translate-y-full',
      )}
      aria-hidden={!showBar}
    >
      <button
        type="button"
        onClick={handleClick}
        tabIndex={showBar ? 0 : -1}
        className="flex w-full items-center justify-center gap-2 rounded-xl bg-brand-accent py-3.5 text-base font-bold text-brand-dark shadow-lg"
        data-cta="sticky-mobile"
      >
        Generar análisis gratis
        <ArrowRight className="h-5 w-5" />
      </button>
    </div>
  );
}
